import { CmsInsight } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class Insight {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadInsightList
			 * @param {Object} filters - Optional filter parameters
			 */
			async loadInsightList({ rootState }, filters = {}) {
				const domain = rootState.CmsSite.site.name || 'default';
				const payload = {
					limit: filters.limit || 6,
					offset: filters.offset || 0,
					order: { direction: 'desc', property: 'created' }
				};
				return CmsInsight.list(payload, domain);
			},

			/**
			 * @async @name loadInsightItem
			 * @param {function} commit
			 * @param {string} id
			 */
			async loadInsightItem(context, id) {
				return CmsInsight.get(id);
			}
		};
	}
}
